/*
 * Copyright 2026 North Carolina State University
 */

import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const BASIS_OPTIONS = ['day', 'month', 'year', 'hour', 'unit'];

const HELP =
  'Compartments: day bills per day; month and year are pro-rated by the real days in each ' +
  'calendar month / year (leap years included). Resources are billed by quantity, so here it is a label only.';

/**
 * Billing basis of a rate: pick day / month / year, or type a label such as
 * "bag" for a resource rate. Calls onChange with the string value.
 */
const RateBasisField = ({ value, onChange, size = 'small', fullWidth = false, margin, compact = false }) => (
  <Autocomplete
    freeSolo
    options={BASIS_OPTIONS}
    value={value || ''}
    onChange={(_, v) => onChange(v || '')}
    onInputChange={(_, v, reason) => { if (reason === 'input') onChange(v); }}
    fullWidth={fullWidth}
    sx={compact ? { minWidth: 130 } : undefined}
    renderInput={(params) => (
      <TextField
        {...params}
        label={compact ? 'Per' : 'Billing Basis'}
        size={size}
        margin={margin}
        placeholder="day"
        helperText={compact ? '/ ___' : HELP}
      />
    )}
  />
);

export default RateBasisField;
